import {
  Component,
  Input,
  Output,
  TemplateRef,
  OnInit,
  SimpleChanges,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { IPropertyRentTermModel } from '../../../shared/models/PropertyRentTermModel';
import { ValidationService } from '../../../shared/providers/validation.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-property-history-rent-term',
  templateUrl: './property-history-rent-term.component.html',
  styleUrls: ['./property-history-rent-term.component.css'],
})
export class PropertyHistoryRentTermComponent implements OnInit {
  @Input() PropertyHistoryRentTerms = [] as IPropertyRentTermModel[];
  @Output() saveRentTerm = new EventEmitter();
  @Input() IsEditAllowed: boolean;
  @Input() saleDate: Date | null;
  optionsCount: number;
  autoCalcRentTerm = false as boolean;
  rentTermToDelete: number;
  modalRef: BsModalRef;
  currentData = {} as IPropertyRentTermModel;
  tempDataIndex = -1 as number;
  IsStartDateValid = false as boolean;
  IsEndDateValid = false as boolean;
  IsValidNetOperatingIncome = false as boolean;
  IsValidYears = false as boolean;

  constructor(
    private _validationService: ValidationService,
    private modalService: BsModalService,
    private Toast: ToastService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (
      this.PropertyHistoryRentTerms != undefined &&
      this.PropertyHistoryRentTerms != null &&
      this.PropertyHistoryRentTerms.length > 0
    ) {
      this.PropertyHistoryRentTerms.forEach((item) => {
        item.LeaseStartDate = this._validationService.convertUTCDateToLocalDate(
          item.LeaseStartDate
        );
        item.LeaseEndDate = this._validationService.convertUTCDateToLocalDate(
          item.LeaseEndDate
        );
      });
    }
  }
  showRentTermOptions(index) {
    var status = false;
    var count = 0;
    if (index == 0) {
      this.optionsCount = 0;
    }
    this.PropertyHistoryRentTerms.forEach((res) => {
      if (res.IsOptional) {
        if (count == index && this.optionsCount == 0) {
          status = true;
          this.optionsCount = 1;
        }
      }
      count++;
    });
    return status;
  }

  showCurrentDate(currentitem) {
    let date = new Date();
    var status = false;
    if (
      currentitem.LeaseStartDate <= date &&
      currentitem.LeaseEndDate >= date
    ) {
      status = true;
    }

    return status;
  }

  showSaleDate(currentitem) {
    var status = false;
    if (
      currentitem.LeaseStartDate <= this.saleDate &&
      currentitem.LeaseEndDate >= this.saleDate
    ) {
      status = true;
    }

    return status;
  }

  openEditRentTermTable(item, index) {
    if (
      this.PropertyHistoryRentTerms.findIndex(
        (item) => item.IsEditModeOn == true
      ) > -1
    ) {
      this.Toast.addToast({
        title: 'You have unsaved data on rent schedule',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    } else {
      this.PropertyHistoryRentTerms.forEach((item) => {
        item.IsEditModeOn = false;
      });
      this.currentData = Object.assign({}, item);

      item.IsEditModeOn = true;
    }
  }

  openModal(template: TemplateRef<any>, classes: any, index: number) {
    if (
      this.PropertyHistoryRentTerms.findIndex((x) => x.IsEditModeOn == true) ==
      -1
    ) {
      this.rentTermToDelete = index;
      this.modalRef = this.modalService.show(template, { class: classes });
    } else {
      this.Toast.addToast({
        title: 'Please save unsaved data on rent schedule',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  deleteRentTerm($event) {
    this.PropertyHistoryRentTerms.splice(this.rentTermToDelete, 1);
    this.saveRentTerm.emit(this.PropertyHistoryRentTerms);
  }

  dateOverlapValidation(date, dateType, index) {
    let status = true;
    let toastMsg = '';
    let overlapingRows = [];
    if (!this._validationService.IsDate(date)) {
      if (dateType == 1) {
        this.IsStartDateValid = true;
      } else if (dateType == 2) {
        this.IsEndDateValid = true;
      }
    } else {
      for (let i = index + 1; i < this.PropertyHistoryRentTerms.length; i++) {
        if (
          date > this.PropertyHistoryRentTerms[i].LeaseStartDate ||
          date > this.PropertyHistoryRentTerms[i].LeaseEndDate
        ) {
          status = false;
          overlapingRows.push(i + 1);
        }

        if (dateType == 1) {
          //start date
          toastMsg = 'Start Date';
          this.IsStartDateValid = !status;
        } else {
          this.IsEndDateValid = !status;
          toastMsg = 'End Date';
        }
      }

      for (let i = 0; i < index; i++) {
        if (
          date < this.PropertyHistoryRentTerms[i].LeaseStartDate ||
          date < this.PropertyHistoryRentTerms[i].LeaseEndDate
        ) {
          status = false;
          overlapingRows.push(i + 1);
        }

        if (dateType == 1) {
          //start date
          this.IsStartDateValid = !status;
          toastMsg = 'Start Date';
        } else {
          this.IsEndDateValid = !status;
          toastMsg = 'End Date';
        }
      }

      if (!status) {
        this.Toast.addToast({
          title: toastMsg + ' Overlaps Rows ' + overlapingRows.join(','),
          timeout: 10000,
          theme: 'bootstrap',
          position: 'bottom-right',
          type: 'error',
        });
      }
    }
  }

  calcIncreasePercent(NetOperatingIncome, Index) {
    if (!NetOperatingIncome) {
      this.Toast.addToast({
        title: 'Please enter a valid rent',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      this.PropertyHistoryRentTerms[Index].NetOperatingIncome = parseInt(
        this.currentData.NetOperatingIncome as any
      );
      this._changeDetectorRef.detectChanges();
    }
  }

  validatePercentage(Increase, Index) {
    if (Increase > 100) {
      this.Toast.addToast({
        title: 'Increase cannot be greater than 100',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      this.PropertyHistoryRentTerms[Index].Increase = this.currentData.Increase;
    } else if (Increase < 0) {
      this.Toast.addToast({
        title: 'Increase cannot be less than 0',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      this.PropertyHistoryRentTerms[Index].Increase = this.currentData.Increase;
    }
  }

  save(item, index) {
    let status = true;
    if (
      this.currentData.Years == undefined ||
      this.currentData.Years.length == 0
    ) {
      this.Toast.addToast({
        title: 'Please enter a valid year',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      status = false;
    }

    if (this.currentData.Increase > 100) {
      this.Toast.addToast({
        title: 'Increase cannot be greater than 100',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      status = false;
    } else if (this.currentData.Increase < 0) {
      this.Toast.addToast({
        title: 'Increase cannot be less than 0',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      status = false;
    } else if (!this.currentData.Increase) {
      this.Toast.addToast({
        title: 'Please enter a valid increase percentage',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      status = false;
    }
    if (
      this.IsStartDateValid ||
      !this._validationService.IsDate(this.currentData.LeaseStartDate)
    ) {
      this.Toast.addToast({
        title: 'Please enter a valid start date',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      status = false;
    }
    if (
      this.IsEndDateValid ||
      !this._validationService.IsDate(this.currentData.LeaseEndDate)
    ) {
      this.Toast.addToast({
        title: 'Please enter a valid end date',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      status = false;
    }
    if (
      !this.IsEndDateValid &&
      this.currentData.LeaseEndDate < this.currentData.LeaseStartDate
    ) {
      this.Toast.addToast({
        title: 'Lease end date should be after the start date',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
      status = false;
    }

    if (status) {
      this.tempDataIndex = -1;
      this.PropertyHistoryRentTerms[index] = this.currentData;
      this.PropertyHistoryRentTerms.forEach((item) => {
        item.IsEditModeOn = false;
      });
      this.saveRentTerm.emit(this.PropertyHistoryRentTerms);
    }
  }

  addRentTermOption() {
    if (
      this.PropertyHistoryRentTerms.findIndex((x) => x.IsEditModeOn == true) ==
      -1
    ) {
      let data = {} as IPropertyRentTermModel;
      data.IsEditModeOn = true;
      data.IsOptional = true;
      this.PropertyHistoryRentTerms.push(data);
      this.currentData = data;
      this.tempDataIndex = this.PropertyHistoryRentTerms.length - 1;
    } else {
      this.Toast.addToast({
        title: 'Please save unsaved data on rent schedule',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  addRentTerm() {
    if (
      this.PropertyHistoryRentTerms.findIndex((x) => x.IsEditModeOn == true) ==
      -1
    ) {
      let index = 0;
      let data = {} as IPropertyRentTermModel;
      data.IsEditModeOn = true;
      data.IsOptional = false;
      this.tempDataIndex = this.PropertyHistoryRentTerms.findIndex(
        (x) => x.IsOptional == true
      );
      if (this.tempDataIndex == -1) {
        this.tempDataIndex = this.PropertyHistoryRentTerms.length;
      }
      this.PropertyHistoryRentTerms.splice(this.tempDataIndex, 0, data);
      this.currentData = data;
    } else {
      this.Toast.addToast({
        title: 'Please save unsaved data on rent schedule',
        timeout: 10000,
        theme: 'bootstrap',
        position: 'bottom-right',
        type: 'error',
      });
    }
  }

  cancelEdit(item, i) {
    item.IsEditModeOn = false;
    if (this.tempDataIndex > -1) {
      this.PropertyHistoryRentTerms.splice(i, 1);
    }
  }

  validateUnsavedDate() {
    let result = true;
    if (
      this.PropertyHistoryRentTerms.findIndex(
        (item) => item.IsEditModeOn == true
      ) > -1
    ) {
      result = false;
    }

    return result;
  }
}
